import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/FileUpload/sgds-file-upload";
import { register } from "../../utils/ce-registry";

register("sgds-file-upload", Component);

export default createComponent({
  react: React,
  tagName: "sgds-file-upload",
  elementClass: Component,
  events: {
    onSgdsFilesSelected: "sgds-files-selected",
    onSgdsAddFiles: "sgds-add-files",
    onSgdsRemoveFile: "sgds-remove-file",
    onSgdsChange: "sgds-change"
  }
});
